import {charcoal} from '../sass/base/_exports.sass';

export const PhotoGalleryIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.666 2.66797H10.666C9.19535 2.66797 7.99935 3.86397 7.99935 5.33464V21.3346C7.99935 22.8053 9.19535 24.0013 10.666 24.0013H26.666C28.1367 24.0013 29.3327 22.8053 29.3327 21.3346V5.33464C29.3327 3.86397 28.1367 2.66797 26.666 2.66797ZM10.666 21.3346V5.33464H26.666L26.6687 21.3346H10.666Z"
        fill={color}
      />
      <path
        d="M5.33268 10.668H2.66602V26.668C2.66602 28.1386 3.86202 29.3346 5.33268 29.3346H21.3327V26.668H5.33268V10.668Z"
        fill={color}
      />
      <path
        d="M15.9993 16.0013L14.666 14.668L11.9993 18.668H25.3327L19.9993 10.668L15.9993 16.0013Z"
        fill={color}
      />
    </svg>
  );
};
